import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getApplicableTaxes(action: any): any {
    const url = APIS.ADDITIONAL_TAX.GET_APPLICABLE;
    yield call(sagaFunction, action, CallApi.POST, url, action.payload, true);
}
